/**
 * Aplikace Tisky. WidgetShell už kreslí kartu, tělo nepřidává další.
 */
import { Printer } from 'lucide-react';
import type { WidgetSpec } from './types';
import { PrintStatsPanel } from '../pages/modules/print-stats';

function PrintsWidget() {
  return <PrintStatsPanel mode='app' />;
}

export const PRINTSERVER_WIDGETS: WidgetSpec[] = [
  {
    id: 'printserver.prints',
    title: 'Tisky',
    module: 'printserver',
    kind: 'custom',
    format: 'lg',
    formats: ['lg'],
    icon: Printer,
    component: PrintsWidget,
    phone: PrintsWidget,
  },
];
